import { api_update_profile_path } from '../../routes';
import request from './request';

export interface ProfileParams {
  topics?: string[];
  interests?: string[];
}

export async function updateProfile(profile: ProfileParams): Promise<Record<string, never>> {
  const res = await request('post', api_update_profile_path({ profile: JSON.stringify(profile) }));
  return res;
}
